import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteNok } from "../api/nok";
import { DeleteMobility } from "../types/types";
import { useSnackbar } from "notistack";

const useDeleteNok = ({ seq }: DeleteMobility, closeModal: () => void) => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const mutation = useMutation({
    mutationFn: () => deleteNok({ seq }),
    onSuccess: () => {
      // console.log(data);
      queryClient.invalidateQueries({ queryKey: ["Nok"] });
      enqueueSnackbar(`추가 알림 수신자 삭제 성공`, {
        variant: "success",
      });
      closeModal();
    },
  });
  return mutation;
};

export default useDeleteNok;
